import { Info } from "lucide-react";
import { Button } from "@/components/ui/button";

const ApplePayNotice = ({ closeModal }: { closeModal: () => void }) => {
  return (
    <div className="my-4 flex w-full flex-col items-center gap-4">
      <div
        className="flex size-16 items-center justify-center rounded-full border border-dark-primary-main"
        style={{
          background:
            "linear-gradient(100.47deg, rgba(225, 225, 225, 0.4) 9.36%, rgba(225, 225, 225, 0.15) 100%)",
        }}
      >
        <Info className="size-7 text-dark-primary-main" />
      </div>
      <div className="mt-2 text-center">
        <p className="text-2xl font-medium">Apple Pay Update</p>
        <p className="mx-auto mt-2 max-w-[90%] text-sm leading-5 font-normal text-dark-text-300">
          We’re aware that some users are experiencing issues adding their platinum Mastercard to Apple Pay. Our team is working with our partners to resolve this as soon as possible. We apologise for the inconvenience and appreciate your patience.
        </p>
      </div>
      <Button
        onClick={closeModal}
        className="text-dark-text-400 bg-dark-primary-main hover:bg-dark-primary-main/80 mt-4 h-11 w-full"
      >
        Continue
      </Button>
    </div>
  );
};

export default ApplePayNotice;
